import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'loader',
  templateUrl: './loader.html',
  styleUrls: ['./loader.scss'],
  standalone: true,
  imports: [
    CommonModule,
  ],
})

export class Loader {

  @Input() pageLoader: boolean = false;
  @Input() miniLoader: boolean = false;

  constructor() {

  }

  ngOnInit() {

  }
}
